const MS_STORE_PROTOCOL_URL = "ms-windows-store://pdp/?productid=9nklh6b1fpnn";
const MS_STORE_WEB_URL = "https://apps.microsoft.com/detail/9nklh6b1fpnn";

const isWindows = (): boolean => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const platform = (navigator as unknown as { userAgentData?: { platform?: string } }).userAgentData?.platform || "";
  return /Windows/i.test(ua) || /Windows/i.test(platform);
};

export const getMicrosoftStoreUrl = (): string =>
  isWindows() ? MS_STORE_PROTOCOL_URL : MS_STORE_WEB_URL;

export const MICROSOFT_STORE_WEB_URL = MS_STORE_WEB_URL;
